import { XIcon } from '#app/components/icons'

export default {
	name: 'Tweet',
	slug: 'tweet',
	description: 'Import an X/Twitter Post using its URL',
	version: '1.1.0',
	icon: <XIcon />,
	fields: [
		{
			name: 'Description',
			slug: 'description',
			required: false,
			type: 'text',
			placeholder: 'Description of the tweet',
		},
		{
			name: 'URL',
			slug: 'url',
			required: true,
			type: 'text',
			placeholder: 'Original URL of the tweet',
		},
		{
			name: 'Image Web2 URL',
			slug: 'web2URL',
			required: false,
			hidden: true,
			type: 'text',
			placeholder: 'Cached Web2 URL of the tweet screenshot',
		},
		{
			name: 'IPFS CID',
			slug: 'ipfsCID',
			required: true,
			hidden: true,
			type: 'text',
			placeholder: 'The IPFS CID of the attestation',
		},
		{
			name: 'ArweaveTXID',
			slug: 'arweaveTxId',
			required: true,
			hidden: true,
			type: 'text',
			placeholder: 'The ArweaveTxId of the attestation',
		},
		{
			name: 'Timestamp',
			slug: 'timestamp',
			required: true,
			type: 'date',
			placeholder: 'Date of Tweet',
			hidden: false,
		},
		{
			name: 'User',
			slug: 'user',
			required: false,
			hidden: true,
			type: 'text',
			placeholder: "Twitter user's handle",
		},
		{
			name: 'Content',
			slug: 'content',
			required: false,
			hidden: true,
			type: 'text',
			placeholder: "Tweet's text content",
		},
	],
	info: 'https://atomicform.faq',
}
